define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MScoreOverrideColoursDomain = void 0;
    class MScoreOverrideColoursDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MScoreOverrideColoursDomain.PastureIsAnnual, value: "Pasture is Annual" },
                    { key: MScoreOverrideColoursDomain.PestPlantsPresent, value: "Pest Plants Present" },
                    { key: MScoreOverrideColoursDomain.PastureAnnualAndPestPlantsPresent, value: "Pasture Annual and Pest Plants Present" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MScoreOverrideColoursDomain.PastureIsAnnual] = 0;
                this.KeyIndex[MScoreOverrideColoursDomain.PestPlantsPresent] = 1;
                this.KeyIndex[MScoreOverrideColoursDomain.PastureAnnualAndPestPlantsPresent] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Pasture is Annual"] = 0;
                this.ValueIndex["Pest Plants Present"] = 1;
                this.ValueIndex["Pasture Annual and Pest Plants Present"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MScoreOverrideColoursDomain = MScoreOverrideColoursDomain;
    Object.defineProperty(MScoreOverrideColoursDomain, "PastureIsAnnual", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Yellow"
    });
    Object.defineProperty(MScoreOverrideColoursDomain, "PestPlantsPresent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Black"
    });
    Object.defineProperty(MScoreOverrideColoursDomain, "PastureAnnualAndPestPlantsPresent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "YellowBlack"
    });
    Object.defineProperty(MScoreOverrideColoursDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
